import { Container, Section } from '@components';

const Calendar = () => {
  return (
    <div className="bg-neutral-soft-gray min-h-screen">
      <Section>
        <Container>
          <div className="text-center py-16">
            <h1 className="text-h2 text-primary-navy mb-4">Calendar</h1>
            <p className="text-body text-neutral-medium-gray">
              Coming in Phase 7 - Content Calendar
            </p>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Calendar;
